"use client";

import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";
import { MainWrapper } from "@components/ui/main-wrapper/mainWrapper";
import { trustpilotIntegrationEnabled } from "@config/site/site-config";
import type { PageModule } from "@lib/contentful/mappers/modules/types";
import { ModulesRenderer } from "@lib/contentful/modules-renderer/ModulesRenderer";
import { Box } from "@ecco/ui/box";
import dynamic from "next/dynamic";

const TrustpilotWidget = dynamic(
    () =>
        import("@components/commerce/reviews/trustpilot/TrustpilotReviews").then(
            (mod) => mod.TrustpilotWidget
        ),
    { ssr: false }
);

type HomePageProps = {
    modules: PageModule[];
};

const HomePage = ({ modules }: HomePageProps) => {
    const { siteSettings } = useGlobalContent();

    const authorizationInvitation = siteSettings?.auth.authorizationInvitation;
    const { theme } = siteSettings.promotions;

    return (
        <Box data-testid="Homepage">
            <MainWrapper>
                <ModulesRenderer
                    modules={modules}
                    authorizationInvitation={authorizationInvitation}
                    theme={theme}
                />
                {trustpilotIntegrationEnabled && <TrustpilotWidget />}
            </MainWrapper>
        </Box>
    );
};

export default HomePage;
